<template>
    <v-dialog v-model="getModalRelatorioFechamentoCaixa" persistent :loading="$store.getters.getOverlay"
        max-width="720px" transition="dialog-transition">
        <v-card outlined>
            <v-card-title>Relatório</v-card-title>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12 md12>
                        <v-text-field class="mr-2 ml-2" label="Data" v-model="periodo_inicial" type="date" outlined
                            dense></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 md12>
                        <v-select :items="getFuncionarios" v-model="funcionario_id" item-value="id" item-text="nome"
                            outlined dense class="mr-2 ml-2"></v-select>
                    </v-flex> -->
                    <v-flex xs12 md12>
                        <v-select
                            :items="['A4', 'CUPOM']"
                            label="Modelo Impressão"
                            v-model="modelo_impressao"
                            outlined
                            dense
                            class="ml-2 mr-2"
                        ></v-select>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="setModalRelatorioFechamentoCaixa(false)" :loading="$store.getters.getOverlay" outlined>Voltar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="imprimir" :loading="$store.getters.getOverlay" outlined>Imprimir</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import LancamentoCaixaService from '@/services/LancamentoCaixaService'
    import moment from 'moment'
    export default {
        data() {
            return {
                periodo_inicial: moment().format('YYYY-MM-DD'),
                funcionario_id: '',
                modelo_impressao: 'A4',
            }
        },
        computed: {
            ...mapGetters([
                'getModalRelatorioFechamentoCaixa',
                // 'getFuncionarios'
            ])
        },

        methods: {
            ...mapActions([
                'setModalRelatorioFechamentoCaixa',
                // 'listarFuncionarios',
            ]),
            imprimir() {
                this.$store.commit('setOverlay', true)
                LancamentoCaixaService.relatorioFechamentoCaixa({
                    periodo_inicial: this.periodo_inicial,
                    funcionario_id: this.funcionario_id,
                    modelo_impressao: this.modelo_impressao
                })
                .then(res => {
                    this.$store.commit('setOverlay', false)
                    this.$store.commit('setModalPrint', res.data.pdf_link)
                })
                .catch(e => {
                    this.$store.commit('setOverlay', false)
                    this.$store.commit('snackbarError', 'Erro ao gerar relatório.')
                })
            }
        },
        created() {
            // this.listarFuncionarios()
        }
    }

</script>